/**
 * Project panel
 *
 * Created by stefensuhat on 11/08/18 10.48 AM
 */

import { api } from 'utils/index';

const defaultState = {
    items: [],
    meta: { total: 0, per_page: 0, current_page: 0 },
    approved: false,
    cancelled: false,
    selectedId: null,
    statistic: { total: 0, meta: {} },
    errors: null,
};

export default {
    name: 'mpy',
    state: defaultState,
    reducers: {
        reset: state => ({ ...state, ...defaultState }),
        fetchResponse: (state, payload) => ({ ...state, items: payload.data, meta: payload.meta }),
        approveResponse: (state, payload) => {
            if (payload.errors) {
                return ({ ...state, errors: payload.errors });
            }
            return ({ ...state, approved: true });
        },
        cancelResponse: (state, payload) => {
            if (payload.errors) {
                return ({ ...state, errors: payload.errors });
            }
            return ({ ...state, cancelled: true });
        },
    },
    effects: {
        async fetch(params) {
            await api.get('transactions', { params })
                .then(response => this.fetchResponse(response));
        },

        async approve(id) {
            await api.post(`transactions/${id}/approve`, { service: 'topups' })
                .then(response => this.approveResponse(response));
        },

        async cancel(id) {
            await api.post(`transactions/${id}/cancel`, { service: 'topups' })
                .then(response => this.cancelResponse(response));
        },
    },
    selectors: (slice, createSelector) => ({
        all() {
            return createSelector(slice, state => state.topups, topup => topup.items);
        },
        find() {
            return createSelector(
                this.all,
                (state, selectedId) => selectedId,
                (topups, selectedId) => topups.find(topup => topup.id === selectedId),
            );
        },
    }),
};
